var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23.677 23.677",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#707070;stroke-linecap:round;stroke-linejoin:round}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_-_change_settings",
    "data-name": "Icon - change settings",
    transform: "translate(11.793 11.884)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3204",
    "data-name": "Group 3204",
    transform: "translate(-11.293 -11.293)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12604",
    "data-name": "Path 12604",
    className: "cls-1",
    d: "M20.5 13.086v8a2 2 0 0 1-2 2h-16a2 2 0 0 1-2-2v-16a2 2 0 0 1 2-2h7.625",
    transform: "translate(-.5 -.5)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3203",
    "data-name": "Group 3203",
    transform: "translate(-.5 -.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12605",
    "data-name": "Path 12605",
    className: "cls-1",
    d: "M13.5 14.086h-4v-4L18.793.793a1 1 0 0 1 1.414 0l2.586 2.586a1 1 0 0 1 0 1.414Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_890",
    "data-name": "Line 890",
    className: "cls-1",
    transform: "translate(16.5 3.086)",
    d: "m0 0 4 4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_891",
    "data-name": "Line 891",
    className: "cls-1",
    transform: "translate(8.5 14.086)",
    d: "M1 0 0 1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon_edit.8690eb24b6c1af4987e386ac71817424.svg";
export { ForwardRef as ReactComponent };